import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { CancelMeetingButtonComponent } from './cancel-meeting-button/cancel-meeting-button.component';
import { MeetingCancellationDialogComponent } from './cancel-meeting-dialog/cancel-confirmation-dialog.component';

@NgModule({
  declarations: [CancelMeetingButtonComponent, MeetingCancellationDialogComponent],
  exports: [CancelMeetingButtonComponent],
  imports: [
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    CommonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule,
  ],
})
export class CancelMeetingButtonModule {}
